import React, { useState, useRef, useEffect } from "react";
import {
  Grid,
  Typography,
  TextField,
  FormControl,
  FormControlLabel,
  FormLabel,
  Box,
  Input,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Modal,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { submitScores } from "../../../redux/actions/player-area-action/scores-action";
import { getMinimalCourseList } from "../../../redux/actions/courses-action";
import { borderRadius } from "@mui/system";
import index from "../../MainModal";
import { getAllPlayers } from "../../../redux/actions/player-area-action";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "1px solid #000",
    boxShadow: 24,
    padding: "25px !important",
    // backgroundColor: '#D9D9D9',
    backgroundColor: "#ebebeb",
    width: "90%",
  },
  table: {
    margin: "25px 0 !important",
    overflow: "scroll",
  },
  tableRow: {
    // backgroundColor: "#D9D9D9",
    backgroundColor: "#ebebeb",
    border: "none !important",
  },
  tableCell: {
    padding: "3px !important",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center !important",
  },
  selectBox: {
    backgroundColor: "#ffff",
    width: "125px !important",
    height: "40px !important",
    borderRadius: "5px !important",
  },
  inputBox: {
    width: "40px !important",
    height: "40px !important",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ffff",
    border: "1px solid gray",
    borderTop: "none",
    borderRadius: "0 5px 5px 0 !important",
  },
  playerprofilebtn: {
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
    borderRadius: "5px !important",
    fontWeight: "400 !important",
    minWidth: "175px !important",
    padding: "10px 20px !important",
    textTransform: "capitalize !important",
  },
  addIconBtn: {
    backgroundColor: "#06623B !important",
  },
}));

var rowsP1 = [];
for (var i = 1; i <= 20; i++) {
  rowsP1.push(i);
}

var boxRows = [];
for (var i = 1; i <= 20; i++) {
  boxRows.push(i);
}

const AddScoreCardModal = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const listOfAllPlayers = useSelector(
    (state) => state.playerAreaReducer?.data
  );
  const listOfHomeCourses = useSelector((state) => state.coursesReducer?.data);
  const [data, setData] = useState([
    {
      user_id: "",
      course_id: "",
      user_tee: "",
      scores: [],
    },
  ]);
  const buttonRefs = useRef([]);

  const handlePlayerNameChange = (event, index) => {
    let stateData = [...data];
    stateData[index]["user_id"] = event.target.value;
    setData(stateData);
  };
  const handleUserTeeChange = (event, index) => {
    let stateData = [...data];
    stateData[index]["user_tee"] = event.target.value;
    setData(stateData);
  };
  const handleHomeCourseChange = (event, index) => {
    let stateData = [...data];
    stateData[index]["course_id"] = event.target.value;
    setData(stateData);
  };
  const handleValuesChange = (event, index, childIndex) => {
    const stateData = [...data];
    stateData[index]["scores"][childIndex].push(event.target.value);
    setData(stateData);
  };
  const addRow = (index) => {
    // return console.log('add row index ======> ', index)
    let stateData = data;

    stateData.push({
      user_id: "",
      course_id: "",
      user_tee: "",
      scores: [],
    });
    // return console.log('state data =====> ', stateData);

    setData(stateData);
    // return console.log('state data =====> ', data);
    buttonRefs.current[index].classList.toggle("hide");
  };
  const deleteRow = (e, item) => {
    let stateData = [...data];
    stateData.splice(e, 1);
    setData(stateData);
  };
  const handleSubmitScore = () => {
    // console.log("you are sending this data =========> ", data);
    // dispatch(submitScores(data));
  };

  useEffect(() => {
    dispatch(getMinimalCourseList());
  }, []);

  useEffect(() => {
    // console.log("listOfAllPlayers ==>", listOfAllPlayers);
  }, [listOfAllPlayers]);

  return (
    <Modal open={props.handleOpenModal} onClose={props.handleCloseModal}>
      <Box className={classes.modal}>
        <Grid
          container
          xs={12}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          mb={1}
        >
          <Grid item xs={4}></Grid>
          <Grid item xs={6}>
            <Typography
              variant="h6"
              sx={{
                textTransform: "uppercase",
                fontWeight: 600,
                margin: "10px 0",
              }}
              color={"#000000"}
            >
              Add Scorecard - Bulk Scores
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <IconButton
              aria-label="cancel-modal"
              onClick={props.handleCloseModal}
            >
              <CancelOutlinedIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Divider orientation="horizontal" sx={{ height: "2px !important" }} />

        <Grid container xs={12}>
          <Grid
            item
            xs={12}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Typography
              variant="subtitle1"
              fontWeight={500}
              marginY={1}
              textAlign={"center"}
            >
              Gross Adjusted Scores - Most recent rounds from 1, oldest rounds
              to 20
            </Typography>
          </Grid>
        </Grid>

        <TableContainer component={Paper}>
          <Table aria-label="table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.tableCell}>Player Name</TableCell>
                <TableCell className={classes.tableCell}>User Tee</TableCell>
                <TableCell className={classes.tableCell}>Home Course</TableCell>
                {rowsP1?.map((x, i) => (
                  <TableCell className={classes.tableCell}>{x}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((v, i) => {
                return (
                  <TableRow className={classes.tableRow}>
                    <TableCell className={classes.tableCell}>
                      <FormControl>
                        <Select
                          id="player-name"
                          value={v.user_id}
                          onChange={(e) => handlePlayerNameChange(e, i)}
                          className={classes.selectBox}
                        >
                          {listOfAllPlayers?.map((player, index) => (
                            <MenuItem value={player._id}>
                              {player?.first_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>

                    <TableCell className={classes.tableCell}>
                      <FormControl>
                        <Select
                          id="user-tee"
                          value={v.user_tee}
                          onChange={(e) => handleUserTeeChange(e, i)}
                          className={classes.selectBox}
                        >
                          <MenuItem value={"blue"}>Blue</MenuItem>
                          <MenuItem value={"white"}>White</MenuItem>
                          <MenuItem value={"yellow"}>Yellow</MenuItem>
                          <MenuItem value={"black"}>Black</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>

                    <TableCell className={classes.tableCell}>
                      <FormControl>
                        <Select
                          id="home-course"
                          value={v.course_id}
                          onChange={(e) => handleHomeCourseChange(e, i)}
                          className={classes.selectBox}
                        >
                          {listOfHomeCourses &&
                            listOfHomeCourses?.map((course, index) => (
                              <MenuItem value={course._id}>
                                {course?.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </TableCell>

                    {boxRows?.map((x, childIndex) => (
                      <TableCell className={classes.tableCell} key={childIndex}>
                        <Box className={classes.inputBox}>
                          <TextField
                            onChange={(e) =>
                              handleValuesChange(e, index, childIndex)
                            }
                            value={v.scores[childIndex]}
                            name={i}
                            variant="standard"
                            id="standard-number"
                            InputProps={{
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                              disableUnderline: true,
                              inputProps: {
                                style: { textAlign: "center" },
                                padding: 0,
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    ))}

                    <TableCell className={classes.tableCell}>
                      <IconButton
                        sx={{ marginLeft: "15px" }}
                        onClick={() => addRow(i)}
                        ref={(el) => (buttonRefs.current[i] = el)}
                        color="primary"
                      >
                        <AddCircleIcon />
                      </IconButton>
                    </TableCell>

                    {i > 0 ? (
                      <TableCell className={classes.tableCell}>
                        <Button
                          className={classes.addIconBtn}
                          onClick={() => deleteRow(i, 0, v)}
                          color="error"
                        >
                          <RemoveCircleIcon />
                        </Button>
                      </TableCell>
                    ) : (
                      ""
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            className={classes.playerprofilebtn}
            onClick={() => handleSubmitScore()}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddScoreCardModal;
